"use strict";

import { Box } from '@autoguru/overdrive';
import clsx from 'clsx';
import * as styles from './HeaderLayout.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const HeaderLayout = ({
  children,
  safePaddings: _safePaddings = false,
  transparent: _transparent = false,
  floating: _floating = false,
  className: _className = ''
}) => /*#__PURE__*/_jsx(Box, {
  as: "header",
  display: "flex",
  position: _floating ? 'absolute' : 'relative',
  width: "full",
  justifyContent: "spaceBetween",
  alignItems: "center",
  backgroundColour: _transparent ? 'transparent' : 'white',
  overflow: "hidden",
  paddingX: "4",
  className: clsx(styles.root, _className, {
    [styles.shadow]: !_transparent,
    [styles.safePaddings]: _safePaddings,
    [styles.floating]: _floating
  }),
  children: children
});